import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Plus } from 'lucide-react';

const MyMaintenance = () => {
    const [rows, setRows] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const load = async () => {
        try { const r = await axios.get('/api/portal/maintenance'); setRows(r.data.requests || []); }
        catch { toast.error('Failed'); }
    };
    useEffect(() => { load(); }, []);
    return (
        <div className="max-w-4xl mx-auto space-y-4">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold">Maintenance</h1>
                <button onClick={() => setShowForm(true)} className="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg">
                    <Plus className="h-4 w-4" /> New request
                </button>
            </div>
            <div className="bg-white rounded-xl border">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50 text-left"><tr><th className="p-3">Date</th><th className="p-3">Title</th><th className="p-3">Priority</th><th className="p-3">Status</th></tr></thead>
                    <tbody>{rows.length === 0 ? <tr><td colSpan={4} className="p-6 text-center text-gray-500">No requests yet.</td></tr> :
                        rows.map(r => (
                            <tr key={r.id} className="border-t"><td className="p-3">{new Date(r.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
                                <td className="p-3">{r.title}</td><td className="p-3 capitalize">{r.priority}</td>
                                <td className="p-3"><span className="text-xs px-2 py-0.5 rounded-full bg-blue-100 text-blue-700">{r.workflow_status || r.status}</span></td></tr>
                        ))}</tbody>
                </table>
            </div>
            {showForm && <NewForm onClose={() => setShowForm(false)} onDone={() => { setShowForm(false); load(); }} />}
        </div>
    );
};

const NewForm = ({ onClose, onDone }) => {
    const [f, setF] = useState({ title:'', description:'', priority:'medium' });
    const [saving, setSaving] = useState(false);
    const submit = async e => {
        e.preventDefault(); setSaving(true);
        try { await axios.post('/api/portal/maintenance', f); toast.success('Submitted'); onDone(); }
        catch (err) { toast.error(err.response?.data?.message || 'Failed'); setSaving(false); }
    };
    return (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
            <form onSubmit={submit} className="bg-white rounded-xl max-w-md w-full">
                <div className="p-4 border-b flex justify-between"><h2 className="font-semibold">New maintenance request</h2><button type="button" onClick={onClose}>✕</button></div>
                <div className="p-4 space-y-3">
                    <input required placeholder="Title (e.g. Leaky tap)" className="w-full border rounded-lg px-3 py-2" value={f.title} onChange={e => setF({...f, title:e.target.value})} />
                    <textarea required rows={4} placeholder="Describe the issue" className="w-full border rounded-lg px-3 py-2" value={f.description} onChange={e => setF({...f, description:e.target.value})} />
                    <select className="w-full border rounded-lg px-3 py-2" value={f.priority} onChange={e => setF({...f, priority:e.target.value})}>
                        {['low','medium','high','urgent'].map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                </div>
                <div className="p-4 border-t flex justify-end gap-2">
                    <button type="button" onClick={onClose} className="px-4 py-2 border rounded-lg">Cancel</button>
                    <button disabled={saving} className="px-4 py-2 bg-primary-600 text-white rounded-lg">Submit</button>
                </div>
            </form>
        </div>
    );
};

export default MyMaintenance;
